import React, { createContext, useContext, useState } from "react";

const RestrictedToggleContext = createContext({
  restrictedUnlocked: false,
  toggleRestricted: () => {}
});

export const useRestrictedToggle = () => useContext(RestrictedToggleContext);

export const RestrictedToggleProvider = ({ children }) => {
  const [restrictedUnlocked, setRestrictedUnlocked] = useState(false);

  const toggleRestricted = () => setRestrictedUnlocked((prev) => !prev);

  return (
    <RestrictedToggleContext.Provider value={{ restrictedUnlocked, toggleRestricted }}>
      {children}
    </RestrictedToggleContext.Provider>
  );
};
